import React from 'react';
import clsx from 'clsx';
import moment from 'moment';
import Assessment from '../Assessment/Assessment';
import AssessmentLauncher from '../AssessmentLauncher/AssessmentLauncher';

export default class AssessmentCheckupTile extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			lastAssessmentVisible: false,
			last_user_assessment: this.props.last_user_assessment,
			loading: false,
			user_assessment: this.props.user_assessment
		};
		this.state.assessmentProgress = this.getProgressItem('ASSESSMENT'); //assessmentProgress ? assessmentProgress.status : "NOT_STARTED"
		this.state.progressPercentage = this.getProgressPercentage();

		this.onCompleteAssessment = this.onCompleteAssessment.bind(this);
		this.onShowLastAssessment = this.onShowLastAssessment.bind(this);
		this.onHideLastAssessment = this.onHideLastAssessment.bind(this);
	}

	componentDidMount() {
		$(window).on('onCompleteAssessment', this.onCompleteAssessment);
		this.createDonutCharts();
	}

	componentDidUpdate() {
		this.createDonutCharts();
	}

	render() {
		if (this.props.user_assessment === null) {
			return null;
		}

		var AssessmentCheckupTileClasses = clsx({
			AssessmentCheckupTile: true,
			AssessmentCompleted: this.state.assessmentProgress === 'COMPLETED'
		});

		return (
			<div className={AssessmentCheckupTileClasses}>
				{this.renderBody()}
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
			</div>
		);
	}

	renderBody(tileHead, tileBody, buttonTitle) {
		if (
			this.state.assessmentProgress === 'NOT_STARTED' &&
			!this.state.last_user_assessment
		) {
			//console.log('not started and no last user assessment')
			var tileHead = null;
			var tileBody = (
				<div>
					<div className="hero-image">
						<img src={this.props.hero_image_path} />
					</div>
					<h2>
						Take Control of Your
						<br />
						Financial Future Today
					</h2>
					<p>
						Learn how to save more money, decrease debt, and plan for
						retirement. Start Your Journey with the Financial Fitness
						Checkup&trade; and get your SCORE today!
					</p>
				</div>
			);
			var buttonTitle = 'Discover Your Score Now!';
		} else if (
			this.state.assessmentProgress === 'NOT_STARTED' &&
			this.state.last_user_assessment &&
			this.state.last_user_assessment.data.results &&
			Object.keys(this.state.last_user_assessment.data.results).length
		) {
			//console.log('not started but we do have a last user assessment')
			var tileHead = (
				<div className="AssessmentCheckupTileHeader">
					My Financial Fitness Score&trade;
				</div>
			);
			var tileBody = (
				<div>
					{this.renderGraph(this.state.last_user_assessment.data)}
					{this.renderResults(this.state.last_user_assessment.data)}
				</div>
			);
			var buttonTitle = 'Retake the Checkup';
			var lastCheckupTimestamp = this.renderLastCheckupTimestamp();
		} else if (this.state.assessmentProgress === 'IN_PROGRESS') {
			//console.log('in progress', this.state.progressPercentage)
			var tileHead = (
				<div className="AssessmentCheckupTileHeader">
					My Financial Fitness Score&trade;
				</div>
			);
			var tileBody = (
				<div className="progress-row">
					<div
						className={
							'percentage-circle circle-' +
							this.state.progressPercentage +
							' circle-yellow'
						}
					>
						<span>{this.state.progressPercentage}%</span>
					</div>
					<div className="copy">
						<h2 style={{ textAlign: 'left', marginBottom: 5, fontSize: 16 }}>
							Complete Your Checkup
						</h2>
						<p style={{ textAlign: 'left', marginBottom: 5, fontSize: 14 }}>
							Ready to Know Your Score™? Don’t wait, complete the Checkup now!
						</p>
					</div>
				</div>
			);
			var buttonTitle = 'Continue with Checkup';
			if (this.state.last_user_assessment) {
				var lastCheckupTimestamp = this.renderLastCheckupTimestamp();
			}
		} else if (this.state.assessmentProgress === 'COMPLETED') {
			//console.log('current assessment is completed - this means we just completed the assessment and havent yet refreshed the page')
			var tileHead = (
				<div className="AssessmentCheckupTileHeader">
					My Financial Fitness Score&trade;
				</div>
			);
			var tileBody = (
				<div>
					{this.renderGraph(this.state.user_assessment.data)}
					{this.renderResults(this.state.user_assessment.data)}
				</div>
			);
			var buttonTitle = 'View Your Score';
		}

		return (
			<div>
				{tileHead}
				<div className="AssessmentCheckupTileBody">
					{tileBody}
					<div className="ButtonWrapper">
						<AssessmentLauncher
							assessment_respond_path={this.props.assessment_respond_path}
							user_assessment={this.props.user_assessment}
							display_mode={this.props.display_mode}
							visible={this.props.new_record}
							get_assessment_path={this.props.get_assessment_path}
							buttonTitle={buttonTitle}
							onHide={() => {
								window.location.reload();
							}}
							success_page="AssessmentCheckupSuccess"
						/>
					</div>
					{this.renderLastAssessment()}
					{lastCheckupTimestamp}
				</div>
			</div>
		);
	}

	renderLastAssessment() {
		if (this.state.assessmentProgress === 'COMPLETED') {
			var user_assessment = this.state.user_assessment;
			var ua = this.state.user_assessment.data;
		} else if (
			this.state.last_user_assessment &&
			this.state.last_user_assessment.data
		) {
			var user_assessment = this.state.last_user_assessment;
			var ua = this.state.last_user_assessment.data;
		} else {
			var user_assessment = null;
			var ua = null;
		}

		if (user_assessment && ua) {
			return (
				<Assessment
					{...ua}
					entries={ua.entries}
					template_id={user_assessment.template_id}
					display_mode={this.props.display_mode}
					success_page="AssessmentCheckupSuccess"
					get_assessment_path={this.props.get_assessment_path}
					assessment_respond_path={this.props.assessment_respond_path}
					visible={this.state.lastAssessmentVisible}
					onHide={this.onHideLastAssessment}
					ref="last_assessment"
				/>
			);
		}
	}

	renderLastCheckupTimestamp() {
		if (this.state.last_user_assessment) {
			console.log('last_user_assessment', this.state.last_user_assessment);
			return (
				<div
					className="LastCheckup"
					style={{ cursor: 'pointer' }}
					onClick={this.onShowLastAssessment}
				>
					Last Checkup on{' '}
					{moment(
						this.state.last_user_assessment.updated_at
							? this.state.last_user_assessment.updated_at
							: this.state.last_user_assessment.created_at
					).format('MMM Do YYYY')}
				</div>
			);
		}
	}

	renderGraph(assessment_data) {
		// if (this.state.assessmentProgress === 'COMPLETED') {
		var overall = this.getResultItem(
			'FINANCIAL_FITNESS',
			assessment_data.results
		);
		return (
			<div
				className="Graph"
				style={{ cursor: 'pointer' }}
				onClick={this.onShowLastAssessment}
			>
				<div className="OverallScore">{overall.score.scaled}</div>
				<div className="OutOf">out of {overall.score.scaledMax}</div>
				<div
					className="PositionCircle"
					style={this.getPositionCirclePosition(overall.score.scaled)}
				/>
				<svg
					width="253"
					height="133"
					viewBox="0 0 253 133"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6 126.802C6 77.0603 46.4907 6.59277 126.092 6.59277C205.693 6.59277 246.183 77.0603 246.183 126.802"
						stroke="url(#paint0_linear)"
						strokeWidth="12"
						strokeLinecap="round"
					/>
					<defs>
						<linearGradient
							id="paint0_linear"
							x1="220.134"
							y1="126.899"
							x2="23.8813"
							y2="126.899"
							gradientUnits="userSpaceOnUse"
						>
							<stop stopColor="#84D296" />
							<stop offset="0.458333" stopColor="#FFEA9E" />
							<stop offset="1" stopColor="#F85E5E" />
						</linearGradient>
					</defs>
				</svg>
			</div>
		);
		// }
	}

	renderResults(assessment_data) {
		// if (this.state.assessmentProgress === 'COMPLETED') {
		var results = [];
		var result_objects = {};
		result_objects['CONFIDENCE'] = this.getResultItem(
			'CONFIDENCE',
			assessment_data.results
		);
		result_objects['BEHAVIOR'] = this.getResultItem(
			'BEHAVIOR',
			assessment_data.results
		);
		result_objects['APTITUDE'] = this.getResultItem(
			'APTITUDE',
			assessment_data.results
		);

		for (var i in result_objects) {
			var result = result_objects[i];
			if (result) {
				results.push(
					<div className="BodyRow" key={i}>
						<div className="BodyRowName pull-left">{i.toLowerCase()}</div>
						<div className="BodyRowValue pull-right">
							<strong>{result.score.scaled}</strong> / {result.score.scaledMax}
						</div>
					</div>
				);
			}
		}

		return (
			<div style={{ cursor: 'pointer' }} onClick={this.onShowLastAssessment}>
				{results}
			</div>
		);
		// }
	}

	/**
   * Helper functions
   */

	createDonutCharts() {
		$("<style type='text/css' id='dynamic' />").appendTo('head');
		$('div[chart-type*=donut]').each(function() {
			var d = $(this);
			var id = $(this).attr('id');
			var max = $(this).data('chart-max');
			if ($(this).data('chart-text')) {
				var text = $(this).data('chart-text');
			} else {
				var text = '';
			}
			if ($(this).data('chart-caption')) {
				var caption = $(this).data('chart-caption');
			} else {
				var caption = '';
			}
			if ($(this).data('chart-initial-rotate')) {
				var rotate = $(this).data('chart-initial-rotate');
			} else {
				var rotate = 0;
			}
			var segments = $(this).data('chart-segments');

			for (var i = 0; i < Object.keys(segments).length; i++) {
				var s = segments[i];
				var start = s[0] / max * 360 + rotate;
				var deg = s[1] / max * 360;
				if (s[1] >= max / 2) {
					d.append(
						'<div class="large donut-bite" data-segment-index="' + i + '"> '
					);
				} else {
					d.append('<div class="donut-bite" data-segment-index="' + i + '"> ');
				}
				var style =
					$('#dynamic').text() +
					'#' +
					id +
					' .donut-bite[data-segment-index="' +
					i +
					'"]{-moz-transform:rotate(' +
					start +
					'deg);-ms-transform:rotate(' +
					start +
					'deg);-webkit-transform:rotate(' +
					start +
					'deg);-o-transform:rotate(' +
					start +
					'deg);transform:rotate(' +
					start +
					'deg);}#' +
					id +
					' .donut-bite[data-segment-index="' +
					i +
					'"]:BEFORE{-moz-transform:rotate(' +
					deg +
					'deg);-ms-transform:rotate(' +
					deg +
					'deg);-webkit-transform:rotate(' +
					deg +
					'deg);-o-transform:rotate(' +
					deg +
					'deg);transform:rotate(' +
					deg +
					'deg); background-color: ' +
					s[2] +
					';}#' +
					id +
					' .donut-bite[data-segment-index="' +
					i +
					'"]:BEFORE{ background-color: ' +
					s[2] +
					';}#' +
					id +
					' .donut-bite[data-segment-index="' +
					i +
					'"].large:AFTER{ background-color: ' +
					s[2] +
					';}';
				$('#dynamic').text(style);
			}

			d
				.children()
				.first()
				.before(
					"<div class='donut-hole'><span class='donut-filling'>" +
						text +
						'</span></div>'
				);
			d.append(
				"<div class='donut-caption-wrapper'><span class='donut-caption'>" +
					caption +
					'</span></div>'
			);
		});
	}

	getProgressItem(targetType, data) {
		var pi = null;

		if (
			typeof data === 'undefined' &&
			this.state.user_assessment &&
			this.state.user_assessment.data
		) {
			data = this.state.user_assessment.data;
		}

		if (data && data.progress && data.progress.items) {
			for (var i = 0, ilen = data.progress.items.length; i < ilen; i++) {
				var progress_item = data.progress.items[i];
				if (progress_item.targetType === targetType) {
					pi = progress_item;
					break;
				}
			}
		}

		return pi ? pi.status : 'NOT_STARTED';
	}

	getResultItem(key, results) {
		for (var i in results) {
			var result = results[i];
			if (result && result.type === key) {
				return result;
			}
		}
	}

	getPositionCirclePosition(value) {
		if (value === 0) {
			return { top: 112, left: -5 };
		} else if (value > 0 && value < 1) {
			return { top: 90, left: -2 };
		} else if (value >= 1 && value < 2) {
			return { top: 78, left: 2 };
		} else if (value >= 2 && value < 3) {
			return { top: 60, left: 10 };
		} else if (value >= 3 && value < 4) {
			return { top: 40, left: 23 };
		} else if (value >= 4 && value < 5) {
			return { top: 4, left: 70 };
		} else if (value === 5) {
			return { top: -4, left: 116 };
		} else if (value > 5 && value < 6) {
			return { top: 2, left: 155 };
		} else if (value >= 6 && value < 7) {
			return { top: 12, left: 176 };
		} else if (value >= 7 && value < 8) {
			return { top: 42, left: 210 };
		} else if (value >= 8 && value < 9) {
			return { top: 68, left: 225 };
		} else if (value >= 9 && value < 10) {
			return { top: 94, left: 233 };
		} else if (value === 10) {
			return { top: 113, left: 235 };
		}
	}

	getProgressPercentage(data) {
		var allElements = 0;
		var completedElements = 0;

		if (
			typeof data === 'undefined' &&
			this.state.user_assessment &&
			this.state.user_assessment.data
		) {
			data = this.state.user_assessment.data;
		}

		if (
			data &&
			data.progress &&
			data.progress.items &&
			data.progress.items.length
		) {
			for (var i = 0, ilen = data.progress.items.length; i < ilen; i++) {
				var progressItem = data.progress.items[i];
				if (progressItem && progressItem.targetType === 'SECTION') {
					allElements += progressItem.requiredQuestionCount;
					completedElements += progressItem.requiredQuestionAnsweredCount;
				}
			}
		}

		return parseInt(completedElements / allElements * 100);
	}

	reloadAssessment() {
		var self = this;

		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url: this.props.get_assessment_path,
			data: {
				create_assessment: 'n'
			}
		}).done(function(data) {
			//console.log('reloadAssessment done', data)
			if (
				data &&
				data.data &&
				data.assessment_id === self.state.user_assessment.assessment_id
			) {
				//console.log('reload the current assessment into state...', self.getProgressItem('ASSESSMENT', data.data), self.getProgressPercentage(data.data))
				self.setState({
					user_assessment: data,
					assessmentProgress: self.getProgressItem('ASSESSMENT', data.data),
					progressPercentage: self.getProgressPercentage(data.data),
					loading: false
				});
			} else {
				self.setState({ loading: false });
			}
		});
	}

	onCompleteAssessment(event, assessment) {
		var self = this;

		//console.log('onCompleteAssessment', assessment)
		// this.reloadAssessment();
		if (
			assessment &&
			assessment.data &&
			assessment.assessment_id === self.state.user_assessment.assessment_id
		) {
			//console.log('reload the COMPLETED current assessment into state!', self.getProgressItem('ASSESSMENT', assessment.data), self.getProgressPercentage(assessment.data))
			self.setState({
				user_assessment: assessment,
				assessmentProgress: self.getProgressItem('ASSESSMENT', assessment.data),
				progressPercentage: self.getProgressPercentage(assessment.data),
				loading: false
			});
		} else {
			self.setState({ loading: false });
		}
	}

	onHideLastAssessment() {
		this.setState({ lastAssessmentVisible: false });
	}

	onShowLastAssessment() {
		this.setState({ lastAssessmentVisible: true });
	}
}
